<template>
  <Box>
    <Header
      :status="currentStatus"
      :route="route"
    />

    <Success
      :status="currentStatus"
      :isFetchingRides="isFetchingRides"
      :height="minHeight"
      :items="items"
      @getRideData="getRideData"
      @loadMore="loadMore"
    />

    <Error
      :status="currentStatus"
      :height="minHeight"
      @tryAgain="getData"
    />

    <Loading :status="currentStatus" :height="minHeight" />
  </Box>
</template>

<script>
import { mapState } from 'vuex'
import { STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { catchError } from 'corp-front-vue-commons/src/utils/functions'
import requestStatusMixin from 'mixins/requestStatus'
import Header from './Header'
import Success from './Success'
import Error from './Error'
import Loading from './Loading'

export default {
  name: 'LatestRides',
  mixins: [requestStatusMixin],
  props: {
    route: {
      type: Object
    },
    filters: {
      type: Object,
      default: () => {}
    },
    minHeight: {
      type: Number,
      default: 0
    }
  },
  components: {
    Header,
    Success,
    Error,
    Loading
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    cardBodyHeight () {
      const cardHeader = document.querySelector('[data-id="cardHeader"]')
      return !cardHeader ? this.minHeight : this.minHeight - cardHeader.offsetHeight
    }
  },
  data () {
    return {
      items: [],
      page: 1,
      limit: 25,
      isFetchingRides: false,
      isLastPage: false
    }
  },
  methods: {
    getRideData (data) {
      this.$emit('getRideData', data)
    },

    resetItems () {
      this.items = null
      this.page = 1
      this.limit = 25
      this.isFetchingRides = false
      this.isLastPage = false
    },

    async getData () {
      try {
        const page = this.page
        const limit = this.limit
        const startDate = this.filters.startDate || null
        const endDate = this.filters.endDate || null
        const companyId = this.selectedCompany ? this.selectedCompany.id : null
        const { data: res } = await this.$apiService.reports.getRides(
          { page },
          { limit },
          { startDate },
          { endDate },
          { companyId },
          { orderBy: 'desc' }
        )

        if (!res.data.length) {
          this.isLastPage = true
        }

        this.items = !this.items
          ? res.data
          : this.items.concat(res.data)

        this.setStatus(STATUS_SUCCESS)
      } catch (error) {
        this.setStatus(STATUS_FAILED)
        catchError(error)
      }

      this.isFetchingRides = false
    },

    loadMore (event) {
      if (this.isLastPage || this.isFetchingRides) return

      const wrapper = event.target
      if (wrapper.offsetHeight + wrapper.scrollTop === wrapper.scrollHeight) {
        this.page += 1
        this.getData()
        this.isFetchingRides = true
      }
    }
  },
  watch: {
    activeOption () {
      this.forceRenderChart()
    },

    filters: {
      deep: true,
      handler () {
        this.resetItems()
        this.getData()
      }
    },

    selectedCompany () {
      this.resetItems()
      this.getData()
    }
  },
  mounted () {
    this.resetItems()
    this.getData()
  }
}
</script>
